// extracted by mini-css-extract-plugin
export var circle = "_af-1";
export var exitConfirmationModal = "_af-5";
export var iframe = "_af-0";
export var offline = "_af-3";
export var online = "_af-2";
export var workstationSelectError = "_af-4";